import { render, staticRenderFns } from "./Transfer_goods.vue?vue&type=template&id=4fc0f1b0&scoped=true&"
import script from "./Transfer_goods.vue?vue&type=script&lang=js&"
export * from "./Transfer_goods.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_goods.vue?vue&type=style&index=0&id=4fc0f1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0f1b0",
  null
  
)

export default component.exports